/**
 * Dispatch a custom event to pause or resume explore scroller
 *
 * @param {boolean} pause - true to pause the scroll and false to resume it
 */
const triggerExploreScroll = pause => {
    const exploreScrollEvent = new CustomEvent('250.explore.scroll', {
        bubbles: true,
        cancelable: true,
        detail: {pause}
    });
    window.dispatchEvent(exploreScrollEvent);
};

export default triggerExploreScroll;
